import ExternalLink from 'components/organisms/ExternalLink';
import usePathnameWithNoLangCode from 'hooks/usePathnameWithNoLangCode';
import React from 'react';
import { Link } from 'react-router-dom';

function MenuItemLink({
  isExternalLink,
  url,
  addReturnTo,
  text,
  openModal,
  openInNewTab,
  noAuth,
  ...rest
}) {
  const pathname = usePathnameWithNoLangCode();
  if (!url) {
    return (
      <button type="button" onClick={rest.onClick} {...rest}>
        {text}
      </button>
    );
  }

  if (isExternalLink) {
    return (
      <ExternalLink
        url={url}
        openInNewTab={openInNewTab}
        noAuth={noAuth}
        rel="noopener noreferrer"
        {...rest}
      >
        {text}
      </ExternalLink>
    );
  }

  const searchParams = new URLSearchParams();
  if (addReturnTo) {
    searchParams.set('returnTo', pathname);
  }

  const to = {
    pathname: url,
    state: { modal: openModal },
    search: searchParams.toString(),
  };

  return (
    <Link to={to} rel="noopener noreferrer" {...rest}>
      {text}
    </Link>
  );
}

export default MenuItemLink;
